var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c("div", { staticClass: "card setting-card" }, [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("suppliers.basic_info"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("suppliers.display_name"))),
          ]),
          _vm._v(" "),
          _vm.viewSupplier && _vm.viewSupplier.name != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewSupplier.name))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("suppliers.primary_contact_name"))),
          ]),
          _vm._v(" "),
          _vm.viewSupplier && _vm.viewSupplier.contact_name != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewSupplier.contact_name))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("suppliers.email"))),
          ]),
          _vm._v(" "),
          _vm.viewSupplier && _vm.viewSupplier.email != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewSupplier.email))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("suppliers.phone"))),
          ]),
          _vm._v(" "),
          _vm.viewSupplier && _vm.viewSupplier.phone != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewSupplier.phone))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("suppliers.primary_currency"))),
          ]),
          _vm._v(" "),
          _vm.viewSupplier && _vm.viewSupplier.currency != null
            ? _c("p", [
                _vm._v(
                  _vm._s(_vm.viewSupplier.currency.code) +
                    "-" +
                    _vm._s(_vm.viewSupplier.currency.name)
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("suppliers.website"))),
          ]),
          _vm._v(" "),
          _vm.viewSupplier && _vm.viewSupplier.website != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewSupplier.website))])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }